// Oliver Sweeney — Cart page interactions
// Depends on: os-cart.js (window.OSCart)

async function refreshCartSection() {
  const res  = await fetch('/cart?sections=template-cart')
  const data = await res.json()
  const html = data['template-cart']
  if (!html) return
  const doc  = document.createElement('div')
  doc.innerHTML = html
  const newSection = doc.querySelector('[data-cart]')
  const curSection = document.querySelector('[data-cart]')
  if (newSection && curSection) {
    curSection.replaceWith(newSection)
    window.initComponents?.(newSection)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async e => {
    // Quantity change
    const qtyBtn = e.target.closest('[data-action][data-key]')
    if (qtyBtn) {
      const key    = qtyBtn.dataset.key
      const action = qtyBtn.dataset.action
      const input  = document.querySelector(`[data-qty="${key}"]`)
      const qty    = input ? parseInt(input.value) : 1
      const newQty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1)
      qtyBtn.closest('.cart__item__quantity')
            ?.querySelectorAll('button').forEach(b => b.disabled = true)
      await window.OSCart.changeItem({ id: key, quantity: newQty })
      await refreshCartSection()
      return
    }

    // Remove item
    const removeBtn = e.target.closest('[data-remove]')
    if (removeBtn) {
      removeBtn.disabled = true
      await window.OSCart.removeItem(removeBtn.dataset.remove)
      await refreshCartSection()
      return
    }

    // Remove tattoo — re-add item without tattoo property, then remove original
    const tattooBtn = e.target.closest('[data-remove-tattoo]')
    if (tattooBtn) {
      tattooBtn.disabled = true
      const key = tattooBtn.dataset.removeTattoo
      const res = await fetch('/cart.js')
      const cart = await res.json()
      const item = cart.items.find(i => i.key === key)
      if (item) {
        await window.OSCart.addItem({ id: item.variant_id, quantity: item.quantity })
        await window.OSCart.removeItem(key)
      }
      await refreshCartSection()
    }
  })
})
